import ErrorMsg from "./ErrMsgs";

export default ErrorMsg;
